import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styles: []
})
export class UnauthorizedComponent implements OnInit {

  constructor( ) {
  }

  ngOnInit() {
  }

}
